import { render, staticRenderFns } from "./ModalResetSessions.vue?vue&type=template&id=f04988a2"
import script from "./ModalResetSessions.vue?vue&type=script&lang=js"
export * from "./ModalResetSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports